import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCheckbox,
  MDBChipsInput,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRadio,
  MDBRow,
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Body from "../components/body/BodyPage";
import arrow from "../components/images/arrow_ic.svg";
import defaultUImg from "../components/images/default-user-img.svg";
import remove from "../components/images/remove.svg";
import voicemail from "../components/images/voicemail_active.svg";
import MainLinks from "../components/navlinks/MainLinks";

import { useTranslation } from "react-i18next";
import GeneralSettings from "../components/editviews/user/GeneralSettings";
import { getSbProductName, getStreamsProductName } from "../apiclients/CommonUtils";

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef();

  const [gsettingsForm, setGsettingsForm] = useState(0);
  const [addonsForm, setAddonsForm] = useState(0);
  const [element, setElement] = useState();

  function closeSave(e) {
    navigate("/userlanding");
  }

  function submitFrms(e) {
    e.stopPropagation();
    e.preventDefault();
    try {
      ref.current.onSubmit();
    } catch (er) { }
  }

  const setTextInputRef = (element) => {
    console.log("222222222222222222222222222222222222222222");
    console.log(element);
  };
  function resetFrms() {
    setGsettingsForm(0);
    setAddonsForm(0);
  }
  console.log(location.state);
  const [userBInfo, setuserBInfo] = useState(
    location.state ? location.state : {}
  );

  const streamsProductName = getStreamsProductName();
  const sbProductName = getSbProductName();
  const [basicActive, setBasicActive] = useState("tab1");
  const [basicActive1, setBasicActive1] = useState("tab4");

  const [basicModal, setBasicModal] = useState(false);
  const [basicModal1, setBasicModal1] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const [verticalActive, setVerticalActive] = useState("tab1");
  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  const handleBasicClick1 = (value) => {
    if (value === basicActive1) {
      return;
    }
    setBasicActive1(value);
  };
  const defaultData = [
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
  ];
  const [contentData, setContentData] = useState(defaultData);

  function UserDetails(props) {
    const [asyncData, setAsyncData] = useState([]);

    const defaultData = [
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
    ];
    const onContentSearch = (value) =>
      setContentData(
        defaultData.filter((item) =>
          item.toLowerCase().startsWith(value.toLowerCase())
        )
      );

    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const acdQueueData = {
      columns: [
        "Name",
        "Extension",
        "Show ACD Queue",
        "Agent Status - Login or Logout of All Assigned Queues",
        "Assign Default ACD Queues",
      ],
      rows: [
        [
          "ALACD Queus in the List",
          " ",
          <input
            type="range"
            name="points"
            onchange="filterme(this.value);"
            min="1"
            step="1"
            id="custom-toggle"
            className="tgl-def"
            max="3"
            value="2"
          />,
          <input
            type="range"
            name="points"
            onchange="filterme(this.value);"
            min="1"
            step="1"
            id="custom-toggle"
            className="tgl-def"
            max="3"
            value="2"
          />,
          <input
            type="range"
            name="points"
            onchange="filterme(this.value);"
            min="1"
            step="1"
            id="custom-toggle"
            className="tgl-def"
            max="3"
            value="2"
          />,
        ],
        [
          "ACMECorp Queue",
          "5800",
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
        ],
        [
          "Premier",
          "5656",
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
        ],
        [
          "SupportACD",
          "5805",
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>,
        ],
      ],
    };

    const [AddExternalNumbers, setAddExternalNumbers] = useState(false);
    const toggleShow42 = () => setAddExternalNumbers(!AddExternalNumbers);

    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleShow12 = () => setAddNumbers(!AddNumbers);

    const [AddSpeedDial, setAddSpeedDial] = useState(false);
    const toggleShow44 = () => setAddSpeedDial(!AddSpeedDial);
    function onSubmit(e, tmodule) { }
    useEffect(() => {
      setTimeout(() => {
        console.log(ref);
        console.log(ref.current);
        console.log("11111111111111111111111111111111111111111111111");
        console.log(element);
        console.log(ref.current);
      }, 5000);
    }, []);
    return (
      <React.Fragment>
        <>
          <MainLinks active={3} />
          <Body
            tablinks={3}
            sublink={8}
            content={
              <>
                <section className="userDetails">
                  <div className="card card-height">
                    <div className="card-header py-3 px-0">
                      <h5 className="mb-0 ">
                        <MDBBreadcrumb>
                          <MDBBreadcrumbItem>
                            <a href="/userlanding">
                              <strong>{t("users")}</strong>
                            </a>
                          </MDBBreadcrumbItem>
                          <MDBBreadcrumbItem active>
                            <a href="/userlanding">
                              <strong>{t("users")}</strong>
                            </a>
                          </MDBBreadcrumbItem>
                          <MDBBreadcrumbItem active>
                            <a href="#">
                              <strong>
                                {userBInfo.fname} {userBInfo.lname}
                              </strong>
                            </a>
                          </MDBBreadcrumbItem>
                        </MDBBreadcrumb>
                      </h5>
                    </div>

                    <div className="card-body px-0">
                      <div className="row pb-0 pt-1">
                        <div className="w-15 ml-0 pos-relative text-center profile_pic">
                          <div className="">
                            <img
                              src={defaultUImg}
                              alt=""
                              className="px-2 w-80 rounded-circle profile_pic"
                            />
                          </div>
                          <div className="position-relative bottom-10">
                            <MDBIcon
                              far
                              icon="edit"
                              className="btn-circle edit-icon profile_edit"
                            />
                            <MDBIcon
                              fas
                              icon="times"
                              className="btn-circle remove-icon profile_cancel"
                            />
                          </div>
                        </div>

                        <div className="w-80 px-0">
                          <h5 className="fw-600 mt-2 ">
                            {userBInfo.fname} {userBInfo.lname}
                          </h5>
                          <p className="mb-1 text-secondary">
                            Extension: {userBInfo.extension}
                          </p>
                          <p className="mb-1 text-secondary">
                            {userBInfo.email}
                          </p>
                          <p className="mb-1 text-secondary">
                            <ul className="d-flex w-50 ps-3 justify-content-between profile_pic">
                              <li className="">{t("HelpCenter")}</li>
                              <li className="">{t("SuperAdmin")}</li>
                              <li className="">{t("Supervisor")}</li>
                            </ul>
                          </p>
                        </div>
                      </div>

                      <MDBTabs className="mt-2">
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab1")}
                            active={basicActive === "tab1"}
                          >
                            {t("settings")}
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab2")}
                            active={basicActive === "tab2"}
                          >
                            {JSON.parse(sessionStorage.getItem("admin_session")).streams_productname}
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab3")}
                            active={basicActive === "tab3"}
                          >
                            {t("callRouting")}
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab4")}
                            active={basicActive === "tab4"}
                          >
                            {t("integrations")}
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab5")}
                            active={basicActive === "tab5"}
                          >
                            {t("ACDQueueCP")}
                          </MDBTabsLink>
                        </MDBTabsItem>
                      </MDBTabs>

                      <MDBTabsContent>
                        <MDBTabsPane open={basicActive === "tab1"}>
                          {/* Tab 1 content */}
                          <MDBRow>
                            <MDBCol
                              size="2"
                              md="2"
                              lg="2"
                              sm="12"
                              className="col-sm-100 pr-0 leftTabs leftTabs__fix"
                            >
                              <MDBTabs className="flex-column text-center">
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Addons"
                                    onClick={() => handleVerticalClick("tab1")}
                                    active={verticalActive === "tab1"}
                                  >
                                    {t("general")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Addons"
                                    onClick={() => handleVerticalClick("tab2")}
                                    active={verticalActive === "tab2"}
                                  >
                                    {t("Add-Ons")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#CallingandSMS"
                                    onClick={() => handleVerticalClick("tab3")}
                                    active={verticalActive === "tab3"}
                                  >
                                    {t("CallingandSMS")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#CallRecording"
                                    onClick={() => handleVerticalClick("tab4")}
                                    active={verticalActive === "tab4"}
                                  >
                                    {t("CallRecording")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Groups"
                                    onClick={() => handleVerticalClick("tab5")}
                                    active={verticalActive === "tab5"}
                                  >
                                    {t("Groups")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#PhonesandDevices"
                                    onClick={() => handleVerticalClick("tab6")}
                                    active={verticalActive === "tab6"}
                                  >
                                    {t("IP-PhonesandDevices")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Fax"
                                    onClick={() => handleVerticalClick("tab7")}
                                    active={verticalActive === "tab7"}
                                  >
                                    {t("Fax")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#ConferenceBridge"
                                    onClick={() => handleVerticalClick("tab8")}
                                    active={verticalActive === "tab8"}
                                  >
                                    {t("ConferenceBridge")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Smartbox"
                                    onClick={() => handleVerticalClick("tab9")}
                                    active={verticalActive === "tab9"}
                                  >
                                   {JSON.parse(sessionStorage.getItem("admin_session")).sb_productname}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#voicemail"
                                    onClick={() => handleVerticalClick("tab10")}
                                    active={verticalActive === "tab10"}
                                  >
                                    {t("VoiceMail")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              </MDBTabs>
                            </MDBCol>



                            <MDBCol
                              size="12"
                              md="10"
                              sm="12"
                              pr-0
                              className="col-sm-100 pr-0 leftTabContent"
                            >
                              <div className="vtabHeight huntgroup ps-2 ">
                                <div className="w-95">
                                  <GeneralSettings

                                    ref={ref}
                                    userBInfo={userBInfo}
                                  />
                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Addons"
                                  >
                                    {t("Add-Ons")}
                                  </div>

                                  <div className="ps-0">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("DigitalFaxUnlmited")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div>
                                        <div className="tel-numbers">
                                          {t("DigitalFax")}
                                        </div>
                                        <span className="phrecording">
                                          {t("DigitalFaxtxt")}
                                        </span>
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SpeechtoText")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SmartboxEntUpgrade", {"SB_PRODUCT_NAME" : sbProductName})}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("MSTeamsConnectorAdd-On")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="CallingandSMS"
                                  >
                                    {t("CallingandSMS-On")}
                                  </div>
                                  <div className="ps-0">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("callerID")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <div className="phoneselect w-100">
                                          <select
                                            className="form-control form-select selectname w-100"
                                            name="San Jose"
                                          >
                                            <option value="San Jose">
                                              408 702 2241
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("telephone_Numbers")}
                                      </div>
                                      <MDBBtn
                                        className="m-2"
                                        onClick={toggleShow12}
                                      ><MDBIcon fas icon="plus" size="sm" />  {t("add_Numbers")}
                                      </MDBBtn>
                                    </div>
                                    <div className="mt-2">
                                      <MDBChipsInput
                                        editable
                                        initialValues={[
                                          { tag: "661 863 8829" },
                                          { tag: "MDBAngular" },
                                          { tag: "MDB5" },
                                        ]}
                                      />
                                    </div>

                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("CallingPermission")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <div className="phoneselect w-100">
                                          <select
                                            className="form-control form-select selectname w-100"
                                            name="San Jose"
                                          >
                                            <option value="San Jose">
                                              International and Caribbear
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                            <option value="San Jose">
                                              San Jose
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("AllowUsersCallerID")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("AutoLocalCallerID")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("DisableCallerID")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SMSEnable")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SMSDefaultNo")}
                                      </div>
                                      <div className="phoneselect w-30">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="San Jose"
                                        >
                                          <option value="San Jose">
                                            408 702 2241
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("CTC")}
                                      </div>
                                      <div className="phoneselect w-30 flex-column-sm">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="San Jose"
                                        >
                                          <option value="San Jose">
                                            {t("IpPhone")} 1
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="routing-border mt-2"></div>
                                    <div className="general-settings">
                                      {t("MobCallAssignments")}
                                    </div>

                                    <MDBTable>
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col" className="w-80">
                                            {t("Assignment")}
                                          </th>
                                          <th scope="col" className="w-30">
                                            {t("Destination")}
                                          </th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <th scope="row">* 1</th>
                                          <td>
                                            <select
                                              className="form-control form-select selectname w-100"
                                              name="San Jose"
                                            >
                                              <option value="San Jose">
                                                Cell Phone
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th scope="row">* 2</th>
                                          <td>
                                            <select
                                              className="form-control form-select selectname w-100"
                                              name="San Jose"
                                            >
                                              <option value="San Jose">
                                                {t("IpPhone")} 1
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th scope="row">* 3</th>
                                          <td>
                                            <select
                                              className="form-control form-select selectname w-100"
                                              name="San Jose"
                                            >
                                              <option value="San Jose">
                                                {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th scope="row">* 4</th>
                                          <td>
                                            <select
                                              className="form-control form-select selectname w-100"
                                              name="San Jose"
                                            >
                                              <option value="San Jose">
                                                {t("SelectDestination")}
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                              <option value="San Jose">
                                                San Jose
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("AllowUsereditSpamsettings")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="routing-border mt-2"></div>

                                  <div
                                    className="general-settings"
                                    id="CallRecording"
                                  >
                                    {t("CallRecording")}
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnCallRecording")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("AlloweditCallRec")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("RecAllCalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("RecOutboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("RecInboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("RecAllIntCalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("PlayCallRecbeep")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Userpermcallrec")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          {t("IpPhone")} 1
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Groups"
                                  >
                                    {t("Groups")}
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="d-flex">
                                      <MDBBtn
                                        className="m-2"
                                        onClick={toggleShow42}
                                      ><MDBIcon fas icon="plus" size="sm" /> {t("addExternal")}
                                      </MDBBtn>
                                    </div>
                                  </div>
                                  <div className="ps-0">
                                    <MDBTable>
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col" className="w-35">
                                            {t("name")}
                                          </th>
                                          <th scope="col" className="w-35">
                                            {t("Type")}
                                          </th>
                                          <th scope="col" className="w-35">
                                            {t("Roles")}
                                          </th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td scope="row">Sales</td>
                                          <td>Hunt</td>
                                          <td>User . Supervisor</td>
                                        </tr>
                                        <tr>
                                          <td scope="row">SupportACD</td>
                                          <td>ACD Queue</td>
                                          <td>Agent . Supervisor</td>
                                        </tr>
                                        <tr>
                                          <td scope="row">Onboarding</td>
                                          <td>User Group</td>
                                          <td></td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="PhonesandDevices"
                                  >
                                    {t("IP-PhonesandDevices")}
                                  </div>
                                  <div className="ps-0">
                                    <MDBTable>
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col" className="w-30">
                                            {t("phoneName")}
                                          </th>
                                          <th scope="col" className="w-30">
                                            {t("Model")}
                                          </th>
                                          <th scope="col" className="w-30">
                                            {t("MACaddress")}
                                          </th>
                                          <th
                                            scope="col"
                                            className="w-10 text-center"
                                          >
                                            {t("Online")}
                                          </th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td scope="row">Jerome's WX601</td>
                                          <td>Poly VVX601</td>
                                          <td>0004F21F3434</td>
                                          <td className="text-center">
                                            <div className="green-dot"></div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td scope="row">JeromeT58</td>
                                          <td>Yealink T58W</td>
                                          <td>00156SCSS8FB</td>
                                          <td className="text-center">
                                            <div className="red-dot"></div>
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>

                                  <div className="routing-border mt-2"></div>
                                  <div className="general-settings" id="Fax">
                                    Fax
                                  </div>
                                  <div className="ps-0">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("EnableFax")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("name")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <div className="phoneselect w-100">
                                          <input
                                            type="text"
                                            value="Jerome D Friesenhahn Fax"
                                            className="selectname w-100"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("telephone_Numbers")}
                                      </div>
                                      <MDBBtn onClick={toggleShow12}>
                                        <MDBIcon fas icon="plus" size="sm" />  {t("add_Numbers")}
                                      </MDBBtn>
                                    </div>
                                    <div className="mt-2">
                                      <MDBChipsInput
                                        editable
                                        initialValues={[
                                          { tag: "661 863 8829" },
                                          { tag: "MDBAngular" },
                                          { tag: "MDB5" },
                                        ]}
                                      />
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {"Email Address"}
                                      </div>
                                      <div className="d-flex w-30">
                                        <div className="phoneselect w-100">
                                          <input
                                            type="text"
                                            value="Jerome@panterranetworks.com"
                                            className="selectname w-100"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("DefCallerID")}
                                      </div>
                                      <div className="phoneselect w-30">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="San Jose"
                                        >
                                          <option value="San Jose">
                                            408 702 2241
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="ConferenceBridge"
                                  >
                                    {t("ConferenceBridge")}
                                  </div>

                                  <div className="ps-0">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("ConfBridge")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("name")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <div className="phoneselect w-100">
                                          <input
                                            type="text"
                                            value="_derome D Friesennann Briage"
                                            className="selectname w-100"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("extension")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <input
                                          type="text"
                                          value="5575"
                                          className="selectname w-100"
                                        />
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("telephone_Numbers")}
                                      </div>
                                      <MDBBtn onClick={toggleShow12}>
                                        <MDBIcon fas icon="plus" size="sm" />  {t("add_Numbers")}
                                      </MDBBtn>
                                    </div>
                                    <div className="mt-2">
                                      <MDBChipsInput
                                        editable
                                        initialValues={[
                                          { tag: "661 863 8829" },
                                          { tag: "MDBAngular" },
                                          { tag: "MDB5" },
                                        ]}
                                      />
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Pin")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <input
                                          type="text"
                                          value="5575"
                                          className="selectname w-100"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Smartbox"
                                  >
                                    {JSON.parse(sessionStorage.getItem("admin_session")).sb_productname}
                                  </div>
                                  <div className="ps-0">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("EnSmartbox", {"SB_PRODUCT_NAME" : sbProductName})}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SmartBoxaccountsharing", {"SB_PRODUCT_NAME" : sbProductName})}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("AllowSmartBoxLocalSync", {"SB_PRODUCT_NAME" : sbProductName})}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("AllowSmartBoxStreamsMob", {"PRODUCT_NAME" : streamsProductName, "SB_PRODUCT_NAME" : sbProductName})}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="voicemail"
                                  >

                                    {t("Voicemail")}
                                  </div>
                                  <div className="margin-top">
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Pin")}
                                      </div>
                                      <div className="d-flex w-30">
                                        <input
                                          type="text"
                                          value="5575"
                                          className="selectname w-100"
                                        />
                                      </div>
                                    </div>
                                    <div className="add-numbermain flex-column-sm">
                                      <div className="tel-numbers">
                                        {t("unavaliableGreeting")}
                                      </div>
                                      <div className="phoneselect mt-5-sm">
                                        <audio
                                          src="#"
                                          controls
                                          className="audio-controls"
                                        />
                                        <div className="routing-per">
                                          <span>{t("personalized")}</span>
                                          <span className="routing-edit">
                                            {t("edit")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain flex-column-sm">
                                      <div className="tel-numbers">
                                        {t("busyGreeting")}
                                      </div>
                                      <div className="phoneselect mt-5-sm">
                                        <audio
                                          src="#"
                                          controls
                                          className="audio-controls"
                                        />
                                        <div className="routing-per">
                                          <span>{t("default")}</span>
                                          <span className="routing-edit">
                                            {t("edit")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("play_Mess_timestamp")}
                                        <br />
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("email_notif")}
                                        <br />
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("VoiceMailFormat")}
                                      </div>
                                      <div className="phoneselect w-30">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="San Jose"
                                        >
                                          <option value="San Jose">MP3</option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("del_send_message")}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("include_Transcript")}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="btnControls">
                                    <a
                                      onClick={(e) => closeSave(e)}
                                      className="btn btn-secondary"
                                    >
                                      {t("cancel")}
                                    </a>
                                    <MDBBtn
                                      onClick={() => element.log()}
                                      className="btn btn-primary ml-3"
                                    >
                                      {t("saveChanges")}
                                    </MDBBtn>
                                  </div>
                                </div>
                              </div>
                            </MDBCol>
                          </MDBRow>
                        </MDBTabsPane>
                        <MDBTabsPane
                          open={basicActive === "tab2"}
                          className="p-0"
                        >
                          <div className="row">
                            <MDBCol
                              size="2"
                              md="2"
                              lg="2"
                              sm="12"
                              className="col-sm-100 pr-0  leftTabs"
                            >
                              <MDBTabs className="flex-column text-center">
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#general2"
                                    onClick={() => handleVerticalClick("tab1")}
                                    active={verticalActive === "tab1"}
                                  >
                                    {t("general")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Notifications"
                                    onClick={() => handleVerticalClick("tab2")}
                                    active={verticalActive === "tab2"}
                                  >
                                    {t("Notifications")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#SpeedDials"
                                    onClick={() => handleVerticalClick("tab3")}
                                    active={verticalActive === "tab3"}
                                  >
                                    {t("SpeedDials")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              </MDBTabs>
                            </MDBCol>
                            <MDBCol
                              size="12"
                              md="10"
                              sm="12"
                              pr-0
                              className="col-sm-100 pr-0 leftTabContent"
                            >
                              <div className="vtabHeight ps-2 pr-5">
                                <div className="w-95">
                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="general2"
                                  >
                                    {t("general")}
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("ContactVisbity")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          {t("OnlineContacts")}
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("ContactNameOrder")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          First, Last
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("DisplayContactExt")}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("AllowUserdeletemessages")}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("ShowStreamsAnsPopUp", {"PRODUCT_NAME" : streamsProductName})}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Notifications"
                                  >
                                    {t("Notifications")}
                                  </div>
                                  <div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("ShownotifStreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("ShownotifStreamsMob", {"PRODUCT_NAME" : streamsProductName})}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Muteallnotifi")}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("DisablenotifiLikes")}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Soundnewmess")}
                                      </div>
                                      <div className="phoneselect w-30">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="San Jose"
                                        >
                                          <option value="San Jose">
                                            Knock
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("SoundConnectinvite")}
                                      </div>
                                      <div className="phoneselect w-30">
                                        <select
                                          className="form-control form-select selectname w-100"
                                          name="Knock"
                                        >
                                          <option value="Knock">Knock</option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                          <option value="San Jose">
                                            San Jose
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Disablenotifidaily")}
                                      </div>

                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="SpeedDials"
                                  >
                                    {t("SpeedDials")}
                                  </div>
                                  <span className="phrecording">
                                    {t("SpeedDialstxt", {"PRODUCT_NAME" : streamsProductName})}
                                  </span>
                                  <div className="add-numbermain">
                                    {/* <div><div className="tel-numbers">Digital Fax</div></div> */}

                                    <div className="d-flex">
                                      <MDBBtn
                                        className="m-2"
                                        onClick={toggleShow44}
                                      ><MDBIcon fas icon="plus" size="sm" />  Add Speed Dial
                                      </MDBBtn>
                                    </div>
                                  </div>
                                  <div className="px-4">
                                    <MDBTable className="mt-2">
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col" className="w-30">
                                            {t("SpeedDialNumber")}r
                                          </th>
                                          <th scope="col" className="w-30">
                                            {t("name")}
                                          </th>
                                          <th scope="col" className="w-60">
                                            {t("Number")}
                                          </th>
                                          <th
                                            scope="col"
                                            className="w-10 text-center"
                                          >
                                            {t("Remove")}
                                          </th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td scope="row">0</td>
                                          <td>ACME Corp</td>
                                          <td>6618638829</td>
                                          <td className="text-center">
                                            <img
                                              src={remove}
                                              className="close-icon ms-4"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th scope="row">1</th>
                                          <td>Prestige Worldwide</td>
                                          <td>5418569547</td>
                                          <td className="text-center">
                                            <img
                                              src={remove}
                                              className="close-icon ms-4"
                                            />
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>
                                </div>
                              </div>
                              <div className="btnControls">
                                <a className="btn btn-secondary">
                                  {t("cancel")}
                                </a>
                                <MDBBtn className="btn btn-primary ml-3">
                                  {t("saveChanges")}
                                </MDBBtn>
                              </div>
                            </MDBCol>
                          </div>
                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === "tab3"}>
                          {/* <MDBDatatable search data={actionData3} className='mt-2' /> */}

                          <div className="w-80 m-auto">
                            <div className="d-flex justify-content-between flex-column-sm">
                              <strong className="fs-5">
                                {t("CallSchedule")}
                              </strong>
                              <div className="d-flex align-items-center">
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio1"
                                  value="option1"
                                  label="24/7"
                                  inline
                                />
                                <div className="phoneselect">
                                  <select
                                    className="form-control form-select selectname w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">My Plan</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                              </div>
                              <div className="d-flex-sm mt-sm-2">
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio2"
                                  value="option2"
                                  inline
                                />
                                <span>{t("ScheduleDays")}</span>
                              </div>
                            </div>
                            <div className="routing-border"></div>
                            <div className="add-numbermain">
                              <div className="tel-numbers">
                                <strong className="fs-5">
                                  {t("ActiveRoutingPlan")}:
                                  <span className="text-secondary fw-bold">
                                    {t("MyPlan")}
                                  </span>
                                </strong>
                              </div>
                              <div className="d-flex">
                                <button
                                  className="ripple ripple-surface btn btn-primary"
                                  role="button"
                                >
                                  <MDBIcon fas icon="plus" size="sm" /> {t("Addsequence")}
                                </button>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center mt-2 flex-column-sm ip-routing-plan ip-align-items-baseline ip-align-center">
                              <div className="sequence">
                                <div className="sequenceheader">
                                  <span className="d-flex align-items-center">
                                    <label className="fw-bold fs-5">
                                      {t("sequence")} 1
                                    </label>
                                    <MDBBtn
                                      size="sm"
                                      className="buttonsize mx-2"
                                    >
                                      <MDBIcon fas icon="plus" size="sm" /> {t("addDevice")}
                                    </MDBBtn>
                                  </span>
                                  <MDBBtn size="sm" className="buttonsize">
                                    <MDBIcon fas icon="ellipsis-v" />
                                  </MDBBtn>
                                </div>
                                <div className="ringtime ">
                                  <label>{t("RingTime")}</label>
                                  <span className="position-relative">
                                    <MDBInput
                                      label="20"
                                      id="form1"
                                      type="text"
                                    />
                                    <span className="seconds">
                                      {t("seconds")}
                                    </span>
                                  </span>
                                </div>

                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bold">
                                      {t("IpPhone")} 1
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bolder">
                                      {t("IpPhone")} 2
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bold">
                                      {t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bold">
                                      {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <img
                                  src={arrow}
                                  className="w_100px ip-rorate-90 py-15"
                                />
                              </div>

                              <div className="sequence">
                                <div className="sequenceheader">
                                  <span className="d-flex align-items-center">
                                    <label className="fw-bold fs-5">
                                      {t("sequence")} 2
                                    </label>
                                    <MDBBtn
                                      size="sm"
                                      className="buttonsize mx-2"
                                    >
                                      <MDBIcon fas icon="plus" size="sm" /> {t("addDevice")}
                                    </MDBBtn>
                                  </span>
                                  <MDBBtn size="sm" className="buttonsize">
                                    <MDBIcon fas icon="ellipsis-v" />
                                  </MDBBtn>
                                </div>
                                <div className="ringtime ">
                                  <label>{t("RingTime")}</label>
                                  <span className="position-relative">
                                    <MDBInput
                                      label="20"
                                      id="form1"
                                      type="text"
                                    />
                                    <span className="seconds">
                                      {t("seconds")}
                                    </span>
                                  </span>
                                </div>

                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bolder">
                                      {t("IpPhone")} 2
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="">
                                  <div className="sequenceheader">
                                    <label className="fw-bold">
                                      {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                    </label>
                                    <i className="fas fa-xmark text-primary"></i>
                                  </div>

                                  <div className="mx-2">
                                    <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                      <label className="px-0 pe-2">
                                        {t("from")}
                                      </label>
                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <label className="px-2">{t("to")}</label>

                                      <select
                                        name="09:10 AM"
                                        id="09:10 AM"
                                        className="selectdate"
                                      >
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                        <option value="09:10 AM">
                                          09:10 AM
                                        </option>
                                      </select>
                                      <span className="ml-1">
                                        <MDBCheckbox
                                          className="me-0"
                                          name="flexCheck"
                                          value=""
                                          id="flexCheckDefault"
                                          label="24 hours"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <img
                                  src={arrow}
                                  className="w_100px ip-rorate-90 py-15"
                                />
                              </div>
                              <div className="sequence-small">
                                <div className="sequenceheader d-flex flex-column align-items-center">
                                  <label className="fw-bold  fs-5">
                                    {t("Voicemail")}
                                  </label>
                                  <div>
                                    <img src={voicemail} className="mb-2" />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="add-numbermain">
                              <div className="tel-numbers">
                                <strong className="fs-5">
                                  {t("RoutingPlans")}
                                </strong>
                              </div>
                              <div className="d-flex">
                                <button
                                  className="ripple ripple-surface btn btn-primary"
                                  role="button"
                                >
                                  <MDBIcon fas icon="plus" size="sm" /> {t("AddRoutingPlan")} -------------------
                                </button>
                              </div>
                            </div>
                            <MDBTable hover className="mt-2">
                              <MDBTableHead>
                                <tr>
                                  <th scope="col" className="w-90">
                                    {t("name")}
                                  </th>
                                  <th scope="col" className="text-center">
                                    {t("Remove")}
                                  </th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                <tr>
                                  <td scope="row">{t("AllDevices")}</td>
                                  <td> </td>
                                </tr>
                                <tr>
                                  <td scope="row">{t("IPPhonesonly")}</td>
                                  <td> </td>
                                </tr>
                                <tr>
                                  <td scope="row">
                                    {t("StreamsDesktopMobile", {"PRODUCT_NAME" : streamsProductName})}
                                  </td>
                                  <td> </td>
                                </tr>
                                <tr>
                                  <td scope="row">{t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}</td>
                                  <td> </td>
                                </tr>
                                <tr>
                                  <td scope="row">{t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}</td>
                                  <td> </td>
                                </tr>
                                <tr>
                                  <td scope="row">{t("MyPlan")}</td>
                                  <td className="text-center">

                                    <i className="fas fa-xmark text-primary"></i>
                                  </td>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>

                            <div className="routing-border"></div>
                          </div>
                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === "tab4"}>
                          {/* <MDBDatatable search data={actionData3} className='mt-2' /> */}
                          <div className="row">
                            <MDBCol
                              size="2"
                              md="2"
                              lg="2"
                              sm="12"
                              className="col-sm-100 pr-0 leftTabs"
                            >
                              <MDBTabs className="flex-column text-center">
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Zoho"
                                    onClick={() => handleVerticalClick("tab1")}
                                    active={verticalActive === "tab1"}
                                  >
                                    {t("Zoho")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#SalesForce"
                                    onClick={() => handleVerticalClick("tab2")}
                                    active={verticalActive === "tab2"}
                                  >
                                    {t("SalesForce")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Zendesk"
                                    onClick={() => handleVerticalClick("tab3")}
                                    active={verticalActive === "tab3"}
                                  >
                                    {t("Zendesk")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#WebInt"
                                    onClick={() => handleVerticalClick("tab4")}
                                    active={verticalActive === "tab4"}
                                  >
                                    {t("WebInt")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    className=""
                                    href="#Outlook"
                                    onClick={() => handleVerticalClick("tab5")}
                                    active={verticalActive === "tab5"}
                                  >
                                    {t("Outlook")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              </MDBTabs>
                            </MDBCol>
                            <MDBCol
                              size="12"
                              md="10"
                              sm="12"
                              pr-0
                              className="col-sm-100 pr-0 leftTabContent"
                            >
                              <div className="vtabHeight">
                                <div className="w-95">
                                  <div className="general-settings" id="Zoho">
                                    {t("Zoho")}
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnableZoho")}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Loginboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Logoutboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("CTC")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          {t("IpPhone")} 1
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="SalesForce"
                                  >
                                    {t("SalesForce")}
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnableSalesForce")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnableZoho")}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Loginboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Logoutboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("CTC")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          {t("IpPhone")} 1
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Zendesk"
                                  >
                                    {t("Zendesk")}
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnableSalesForce")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      <a className="green-text me-1">
                                        {t("ClikHere")}
                                      </a>
                                      {t("clicktxt")}
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("SalesForceUsername")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <input
                                        type="text"
                                        className="selectname w-100"
                                        value="Jerome@panterranetworks.com"
                                      />
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("SalesForceUsername")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <input
                                        type="password"
                                        className="selectname w-100"
                                        value="12345678"
                                      />
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("AutoStartSalesForce")}
                                    </div>

                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Loginboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Logoutboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("AutoSaveLogCall")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("CTC")}
                                    </div>
                                    <div className="phoneselect w-30">
                                      <select
                                        className="form-control form-select selectname w-100"
                                        name="San Jose"
                                      >
                                        <option value="San Jose">
                                          Follow User's CTC settings
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                        <option value="San Jose">
                                          San Jose
                                        </option>
                                      </select>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>
                                  <div className="general-settings">
                                    {t("Zendesk")}
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("EnableZendesk")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      <a className="green-text me-1">
                                        {t("ClikHere")}
                                      </a>
                                      {t("Cickheretxt", {"PRODUCT_NAME" : streamsProductName})}
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Openticketoutboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("Openticketinboundcalls")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("AutoCreateTicket")}
                                    </div>
                                    <div className="phoneselect">
                                      <label className="switch">
                                        <input className="form-control" type="checkbox" />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>


                                  <div className="routing-border mt-2"></div>

                                  <div
                                    className="general-settings"
                                    id="WebInt"
                                  >
                                    {t("WebInt")}
                                  </div>
                                  <div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("EnWebInt")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div>
                                        <div className="tel-numbers">
                                          {t("WebInt")}
                                        </div>
                                        <span className="phrecording">
                                          {t("WebInttxt", {"PRODUCT_NAME" : streamsProductName})}
                                        </span>
                                      </div>
                                      <MDBBtn><MDBIcon fas icon="plus" size="sm" /> {t("AddWebInt")}</MDBBtn>
                                    </div>
                                    <MDBTable className="mt-2">
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col">{t("EventType")}</th>
                                          <th scope="col">{t("URL")}</th>
                                          <th scope="col">
                                            {t("BrowserBehaviour")}
                                          </th>
                                          <th scope="col">{t("Active")}</th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td scope="row">ACD Call accepted</td>
                                          <td>{streamsProductName} ACD Call Disposition</td>
                                          <td>New Tab</td>
                                          <td>
                                            <div className="phoneselect">
                                              <label className="switch">
                                                <input className="form-control" type="checkbox" />
                                                <span className="slider round"></span>
                                              </label>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td scope="row">
                                            Inbound call accepted
                                          </td>
                                          <td>3rd party Web Application</td>
                                          <td>Current Tab</td>
                                          <td>
                                            <div className="phoneselect">
                                              <label className="switch">
                                                <input className="form-control" type="checkbox" />
                                                <span className="slider round"></span>
                                              </label>
                                            </div>
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>

                                  <div className="routing-border mt-2"></div>
                                  <div
                                    className="general-settings"
                                    id="Outlook"
                                  >
                                    {t("Outlook")}
                                  </div>
                                  <div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("EnableOutlook")}
                                      </div>
                                      <div className="phoneselect">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="add-numbermain">
                                      <div className="tel-numbers">
                                        {t("Nocontdisplay")}
                                      </div>
                                      <div className="phoneselect w-10">
                                        <input
                                          type="text"
                                          className="selectname w-100"
                                          value="50"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="btnControls">
                                <a className="btn btn-secondary">
                                  {t("cancel")}
                                </a>
                                <MDBBtn className="btn btn-primary ml-3">
                                  {t("saveChanges")}
                                </MDBBtn>
                              </div>
                            </MDBCol>
                          </div>
                        </MDBTabsPane>

                        <MDBTabsPane open={basicActive === "tab5"}>
                          {/* <MDBDatatable search data={actionData3} className='mt-2' /> */}
                          <div className="mt-2">
                            <MDBDatatable search data={acdQueueData} sortField="Name" />
                          </div>
                        </MDBTabsPane>
                      </MDBTabsContent>
                    </div>
                  </div>
                </section>

                <MDBModal
                  open={basicModal}
                  setShow={setBasicModal}
                  tabIndex="-1"
                >
                  <MDBModalDialog >
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>{t("add_New_User")}</MDBModalTitle>
                        <MDBBtn
                          className="btn-close"
                          color="none"
                          onClick={toggleShow}
                        ></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="row">
                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("firstName")}
                              id="typeText"
                              type="text"
                            />
                          </div>

                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("lastName")}
                              id="typeText"
                              type="text"
                            />
                          </div>
                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("extension")}
                              id="typeText"
                              type="text"
                            />
                          </div>

                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("DID")}
                              id="typeText"
                              type="text"
                            />
                          </div>
                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("password")}
                              id="typeText"
                              type="text"
                            />
                          </div>

                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("callerID")}
                              id="typeText"
                              type="text"
                            />
                          </div>
                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("voicemain_pin")}
                              id="typeText"
                              type="text"
                            />
                          </div>

                          <div className="col-md-6 py-2">
                            <MDBInput
                              label={t("call_routing")}
                              id="typeText"
                              type="text"
                            />
                          </div>
                          <div className="col-md-6 py-2">
                            <MDBSelect
                              label={t("timezone")}
                              data={[
                                { text: "One", value: "1" },
                                { text: "Two", value: "2" },
                                { text: "Three", value: "3" },
                                { text: "Four", value: "4" },
                                { text: "Five", value: "5" },
                              ]}
                            />
                          </div>
                        </div>
                      </MDBModalBody>

                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={toggleShow}>
                          {t("close")}
                        </MDBBtn>
                        <MDBBtn>{t("addUser")}</MDBBtn>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>

                <MDBModal
                  open={basicModal1}
                  setShow={setBasicModal1}
                  tabIndex="-1"
                >
                  <MDBModalDialog >
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>{t("add_New_User")}</MDBModalTitle>
                        <MDBBtn
                          className="btn-close"
                          color="none"
                          onClick={toggleShow1}
                        ></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="row">
                          <div className="tel-numbers pt-2">
                            <strong>{t("removeHuntGroup")}</strong>
                          </div>
                        </div>
                      </MDBModalBody>

                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={toggleShow1}>
                          {t("close")}
                        </MDBBtn>
                        <MDBBtn>{t("addUser")}</MDBBtn>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>

                <MDBModal
                  open={AddExternalNumbers}
                  setShow={setAddExternalNumbers}
                  tabIndex="-1"
                >
                  <MDBModalDialog centered scrollable size='sm'>
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>{t("addExternal")}</MDBModalTitle>
                        <MDBBtn
                          className="btn-close"
                          color="none"
                          onClick={toggleShow42}
                        ></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div>
                          <div className="tel-numbers">
                            <strong>{t("ExtNumberName")}</strong>
                          </div>
                          <div className="form pt-1">
                            <input
                              type="text"
                              className="form-control"
                              value="Home Office"
                            />
                          </div>
                          <div className="tel-numbers mt-1">
                            <strong>{t("Number")}</strong>
                          </div>
                          <div className="form pt-1">
                            <input
                              type="text"
                              className="form-control"
                              value="5418569547"
                            />
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={toggleShow42}>
                          {t("cancel")}
                        </MDBBtn>
                        <MDBBtn>{t("add")}</MDBBtn>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>

                <MDBModal
                  open={AddNumbers}
                  setShow={setAddNumbers}
                  tabIndex="-1"
                >
                  <MDBModalDialog>
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
                        <MDBBtn
                          className="btn-close"
                          color="none"
                          onClick={toggleShow12}
                        ></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div>
                          <div>
                            <div className="form-group row">
                              <div className="col-12">
                                <div className="form-outlines">
                                  <MDBChipsInput
                                    label="Example label"
                                    editable
                                    initialValues={[
                                      { tag: "661863 8829" },
                                      { tag: "661863 8829" },
                                      { tag: "MDBVue" },
                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <label className="selectall pt-2">
                            {t("selectAll")}
                          </label>
                          <div>
                            <div className="routing-numbers">
                              <div className="numberadd-green">661863 8829</div>
                              <div className="numberadd-green">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                            </div>
                            <div className="routing-numbers">
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                              <div className="numberadd">661863 8829</div>
                            </div>
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={toggleShow12}>
                          {t("close")}
                        </MDBBtn>
                        <MDBBtn>{t("add")}</MDBBtn>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>

                <MDBModal
                  open={AddSpeedDial}
                  setShow={setAddSpeedDial}
                  tabIndex="-1"
                >
                  <MDBModalDialog centered scrollable size='sm'>
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>{t("AddSpeedDial")}</MDBModalTitle>
                        <MDBBtn
                          className="btn-close"
                          color="none"
                          onClick={toggleShow44}
                        ></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div>
                          <div className="tel-numbers">
                            <strong>{t("AddSpeedDialNo")}</strong>
                          </div>
                          <div className="form pt-1">
                            <input type="text" className="form-control w-100" value="1" />
                          </div>
                          <div className="tel-numbers mt-2">
                            <strong>{t("name")}</strong>
                          </div>
                          <div className="form mt-2">
                            <input
                              type="text"
                              className="w-100"
                              value="Prestige Worldwide"
                            />
                          </div>
                          <div className="tel-numbers mt-2">
                            <strong>{t("Number")}</strong>
                          </div>
                          <div className="form pt-1">
                            <input
                              type="text"
                              className="w-100"
                              value="5418569547"
                            />
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={toggleShow44}>
                          {t("cancel")}
                        </MDBBtn>
                        <MDBBtn>{t("add")}</MDBBtn>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>
              </>
            }
          />
          {/* <Footer /> */}
        </>
      </React.Fragment>
    );
  }

  return <UserDetails />;
}
